import { ApolloClient, InMemoryCache } from "@apollo/client";

//dev
let url = "https://vbdacetest.myshopify.com/api/2022-07/graphql.json";
let key = "72b0c54716c1a2019edd58412519f41e";

//prod
// let url = "https://vb-dace-store.myshopify.com/api/2022-10/graphql.json";
// let key = "6646892dbd5dec02654549bd50ea60b2";

export const Client = new ApolloClient({
  uri: url,
  cache: new InMemoryCache(),
  headers: {
    "X-Shopify-Storefront-Access-Token": key,
  },
});

export function performQuery(query, variable) {
  return Client.query({
    query: query,
    variables: variable,
  });
}

export function performMutation(query, variable) {
  return Client.mutate({
    mutation: query,
    variables: variable,
  });
}
